import { Bar, BarChart, Cell, Legend, Tooltip, XAxis, YAxis } from 'recharts';

import { ReportWidgetTooltipContent } from './ReportWidgetTooltipContent';

import type {
    ReportWidgetChartPoint,
    ReportWidgetItem,
} from '../../model/types';
import type { TooltipProps } from 'recharts';

interface ReportWidgetAreaChartProps {
    data: ReportWidgetChartPoint[];
    showLegend: boolean;
    tooltipFormatter: (value: number) => string;
    items: ReportWidgetItem[];
    total: number;
    width?: number;
    height?: number;
    disableAnimation?: boolean;
}

export const ReportWidgetAreaChart = ({
    data,
    showLegend,
    tooltipFormatter,
    items,
    total,
    width,
    height,
    disableAnimation = false,
}: ReportWidgetAreaChartProps) => (
    <BarChart
        data={data}
        width={width}
        height={height}
        margin={{ top: 8, right: 8, left: 8, bottom: 8 }}
    >
        <XAxis dataKey="name" tick={{ fontSize: 12 }} tickLine={false} />
        <YAxis
            tick={{ fontSize: 12 }}
            tickLine={false}
            tickFormatter={(v) => (typeof v === 'number' ? `$${v}` : String(v))}
        />
        <Tooltip
            content={(props: TooltipProps<number, string>) => (
                <ReportWidgetTooltipContent
                    active={props.active}
                    payload={props.payload}
                    label={props.label}
                    tooltipFormatter={tooltipFormatter}
                    total={total}
                    items={items}
                />
            )}
        />
        {showLegend && <Legend />}
        <Bar
            dataKey="value"
            fill="#5ca1ff"
            fillOpacity={0.7}
            radius={[4, 4, 0, 0]}
            isAnimationActive={!disableAnimation}
        >
            {data.map((entry) => (
                <Cell key={entry.id} fill={entry.color} />
            ))}
        </Bar>
    </BarChart>
);
